import { render } from "./PersonalDataScreen.vue?vue&type=template&id=744e7016&scoped=true&lang=html"
import script from "./PersonalDataScreen.vue?vue&type=script&lang=js"
export * from "./PersonalDataScreen.vue?vue&type=script&lang=js"

import "./PersonalDataScreen.vue?vue&type=style&index=0&id=744e7016&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744e7016"]])

export default __exports__